export const GET_VENUES = 'app/Venues/GET_VENUES';
export const GET_VENUES_COUNTRIES = 'app/Venues/GET_VENUES_COUNTRIES';
export const GET_VENUES_PRODUCTIONS = 'app/Venues/GET_VENUES_PRODUCTIONS';
export const GET_VENUES_WITH_PRODUCTIONS = 'app/Venues/GET_VENUES_WITH_PRODUCTIONS';
